import { DropdownButton, DropdownOption, Sizes } from '@dbt-labs/sourdough';

import { Grouping } from '../../typings/costInsights';

const GROUPING_OPTIONS: DropdownOption[] = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Monthly', value: 'monthly' },
];

export const GroupingSelector = ({
  grouping,
  setGrouping,
}: {
  grouping: Grouping;
  setGrouping: (grouping: Grouping) => void;
}) => {
  const selectedOption = GROUPING_OPTIONS.find((option) => option.value === grouping);

  return (
    <DropdownButton
      options={GROUPING_OPTIONS}
      onChange={(selectedOption) => {
        setGrouping(selectedOption.value as Grouping);
      }}
      defaultOption={selectedOption ?? GROUPING_OPTIONS[0]}
      name="View"
      testId="grouping-dropdown"
      trackingId="model-build-chart-grouping-dropdown"
      size={Sizes.sm}
    />
  );
};
